import { unwrap, usersGetMyFavourites } from "../api";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Favourites } from "./useApp";

export function useFavourites({ enabled = true }) {
  const queryClient = useQueryClient();
  const favourites = useQuery<Favourites>({
    queryKey: ["favourites"],
    queryFn: async () => {
      // The endpoint answers with a JSON *string* containing the favourites object, so
      // one parse happens in the client and one has to happen here. An empty body
      // (`unwrap` normalises it to `{}`) means the user has no favourites yet.
      const data = await unwrap(usersGetMyFavourites());
      return typeof data === "string" ? JSON.parse(data) : {};
    },
    retry: false,
    enabled: enabled,
  });

  function setFavourites(payload: any) {
    queryClient.setQueryData(["favourites"], payload);
  }

  return {
    favourites: favourites.data,
    isFavouritesFetching: favourites.isFetching,
    setFavourites,
  };
}
